export const IOS_URL =
  'https://apps.apple.com/ar/app/cookunity-a-chef-marketplace/id1103061273'
export const ANDROID_URL =
  'https://play.google.com/store/apps/details?id=com.cookunity.android.app'
